import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from 'src/styles/media';

import Button from 'src/components/Button';

class SelectBox extends Component {
  static propTypes = {
    selected: PropTypes.number,
    label: PropTypes.string,
    options: PropTypes.array,
    onClick: PropTypes.func,
    largeBtn: PropTypes.bool,
    mobile: PropTypes.bool,
  };

  static defaultProps = {
    largeBtn: false,
    mobile: false,
  };

  handleClick = index => {
    this.props.onClick(index);
  };

  render() {
    const { label, options, largeBtn, selected, mobile } = this.props;

    return (
      <Root mobile={mobile}>
        <LabelWrapper>
          <h4>{label}</h4>
        </LabelWrapper>
        <OptionsWrapper>
          {options.map((option, index) => {
            return (
              <Button
                key={option + index}
                text={option}
                active={index === selected}
                onClick={() => this.handleClick(index)}
                large={largeBtn}
              />
            );
          })}
        </OptionsWrapper>
      </Root>
    );
  }
}

const Root = styled.div`
  transition: all 0.4s ease-out;
  display: ${props => (props.mobile ? 'none' : 'block')};
  @media (min-width: ${media.mdup}) {
    display: block;
  }
`;

const LabelWrapper = styled.div`
  background: #0b1a27;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 30px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    background: #ff7802;
  }

  h4 {
    font-family: ${({ theme }) => theme.fontHeader};
    font-size: 16px;
    font-weight: 500;
    color: #ff7802;
    letter-spacing: 0;
    text-transform: uppercase;
  }
`;

const OptionsWrapper = styled.div`
  background: #f5f5fa;
  padding: 20px 20px;
  padding-bottom: 33px;
  display: flex;
  flex-wrap: wrap;
  transition: all 0.4s ease-out;
`;

export default SelectBox;



// WEBPACK FOOTER //
// ./src/pages/Floorplans/elements/SelectBox.js